// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* Base button reset — replaces ion-button defaults */
:host {
  display: inline-block;
}

button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-family: inherit;
  font-size: inherit;
  cursor: pointer;
  border: none;
  background: transparent;
  color: inherit;
  padding: 0;
  margin: 0;
  text-transform: none;
  letter-spacing: inherit;
  line-height: 1;
  outline: none;
  -webkit-appearance: none;
  appearance: none;
  white-space: nowrap;
  box-sizing: border-box;
}
button:disabled {
  opacity: 0.5;
  cursor: default;
}
button.btn-loading {
  opacity: 1;
  cursor: default;
}
button[hidden] {
  display: none;
}

.btn-spinner {
  display: inline-block;
  width: 1rem;
  height: 1rem;
  border: 2px solid currentColor;
  border-right-color: transparent;
  border-radius: 50%;
  animation: btn-spin 0.6s linear infinite;
}

@keyframes btn-spin {
  to {
    transform: rotate(360deg);
  }
}
.button {
  text-transform: none;
  box-shadow: none;
}

.register-button {
  box-shadow: none;
  text-transform: inherit;
  height: 2.25rem;
  padding-left: 1.1875rem;
  padding-right: 1.1875rem;
  border-radius: 1.125rem;
  font-size: 0.875rem;
  font-weight: 600;
  min-width: 12rem;
  border: none;
  background: var(--color-accent);
  color: #fff;
  cursor: pointer;
  transition: background 0.12s;
}
.register-button:hover:not(:disabled) {
  background: #3d12a2;
}
.register-button:active:not(:disabled) {
  background: #2e0d85;
}
.register-button:disabled {
  opacity: 0.5;
  cursor: default;
}

.sign-up, .sign-up-new {
  color: var(--color-accent);
  border: 1px solid var(--color-accent);
  height: 2.25rem;
  border-radius: 1.125rem;
  padding: 0px 1.625rem;
  font-size: 0.875rem;
  font-weight: 600;
  transition: background 0.12s;
}
.sign-up:hover, .sign-up-new:hover {
  background: rgba(76, 23, 202, 0.08);
}
.sign-up:active, .sign-up-new:active {
  background: rgba(76, 23, 202, 0.15);
}
@media (max-width: 500px) {
  .sign-up, .sign-up-new {
    height: 1.75rem;
    font-size: 0.8125rem;
    border-radius: 0.875rem;
    padding: 0px 0.188rem;
    margin-top: -0.938rem;
  }
}

.sign-up-new {
  height: 1.75rem;
  font-size: 0.8125rem;
  border-radius: 0.875rem;
  padding: 0 0.8rem;
  margin-top: -0.938rem;
}
@media (max-width: 300px) {
  .sign-up-new {
    font-size: 0.625rem;
  }
}

.new-signup-button {
  width: 100vw;
  border-radius: 0rem;
  background: var(--color-accent);
  color: var(--surface-primary);
  font-weight: 600;
  font-size: 1.25rem;
  line-height: 3.5rem;
  letter-spacing: 0.075rem;
  height: 3.5rem;
  margin-inline: 0rem;
  margin: 0rem;
}

.language-button {
  color: var(--text-secondary);
  height: 1.75rem;
  font-size: 0.9rem;
  padding: 0 0.5rem;
  margin-top: -0.938rem;
  gap: 0.25rem;
  background: var(--surface-secondary);
}
.language-button:hover {
  background: var(--surface-secondary);
}

.sign-in {
  color: var(--color-accent);
  border: 1px solid var(--color-accent);
  height: 2.25rem;
  border-radius: 1.125rem;
  padding: 0px 1.375rem;
  font-size: 0.875rem;
  font-weight: 600;
  transition: background 0.12s;
}
.sign-in:hover {
  background: rgba(76, 23, 202, 0.08);
}
.sign-in:active {
  background: rgba(76, 23, 202, 0.15);
}
@media (max-width: 500px) {
  .sign-in {
    height: 1.75rem;
    font-size: 0.8125rem;
    border-radius: 0.875rem;
    padding: 0px 0.281rem;
    margin-top: -0.938rem;
  }
}

.social-icons {
  height: 3.5rem;
  width: 3.5rem;
  border: 1px solid #D7D8DA;
  border-radius: 0.75rem;
  transition: background 0.12s, border-color 0.12s;
}
.social-icons:hover {
  background: var(--surface-tertiary);
  border-color: var(--border-default);
}
.social-icons:active {
  background: var(--surface-active);
}

.spacing {
  margin: 0px 2rem;
}
@media (max-width: 350px) {
  .spacing {
    margin: 0px 1.25rem;
  }
}

.spacing-right {
  margin-right: 2rem;
}
@media (max-width: 350px) {
  .spacing-right {
    margin-right: 1.25rem;
  }
}

.forgot-password {
  margin: 0px;
  padding: 0px;
  color: var(--color-accent);
  height: 2.25rem;
  font-size: 0.875rem;
  background: var(--surface-secondary);
}

.home-new-meeting, .home-room, .delete-contact, .cancel-rename, .meet-later {
  min-width: 12rem;
  height: 2.25rem;
  border-radius: 1.125rem;
  padding-left: 0.963rem;
  padding-right: 0.963rem;
  font-weight: 600;
  font-size: 0.875rem;
  margin: 0px;
  margin-top: 1.5rem;
  margin-right: 1.5rem;
  background: var(--color-accent);
  color: #fff;
  white-space: nowrap;
  transition: background 0.12s, opacity 0.12s;
}
.home-new-meeting:hover, .home-room:hover, .delete-contact:hover, .cancel-rename:hover, .meet-later:hover {
  background: #3d12a2;
}
.home-new-meeting:active, .home-room:active, .delete-contact:active, .cancel-rename:active, .meet-later:active {
  background: #2e0d85;
}
@media (max-width: 576px) {
  .home-new-meeting, .home-room, .delete-contact, .cancel-rename, .meet-later {
    min-width: 9.25rem;
    margin-right: 1rem;
  }
}
@media (max-width: 375px) {
  .home-new-meeting, .home-room, .delete-contact, .cancel-rename, .meet-later {
    min-width: 14rem;
  }
}

.meet-later {
  border-radius: 1.125rem;
  color: var(--color-danger);
  border: 1px solid var(--color-danger);
  background: transparent;
}
.meet-later:hover {
  background: rgba(255, 83, 34, 0.08);
}
.meet-later:active {
  background: rgba(255, 83, 34, 0.15);
}

.cancel-rename {
  border-radius: 1.125rem;
  color: var(--text-secondary);
  border: 1px solid var(--text-secondary);
  background: transparent;
}
@media (min-width: 576px) {
  .cancel-rename {
    color: var(--text-secondary);
    border: 1px solid var(--text-secondary);
    background: transparent;
  }
}

.delete-contact {
  min-width: 8rem;
  margin-top: 1rem;
  margin-bottom: 1rem;
  color: var(--color-danger);
  border-radius: 1.25rem;
  border: 1px solid var(--color-danger);
  background: transparent;
  padding-left: 1rem;
  padding-right: 1rem;
}

.home-room {
  margin-top: 3rem !important;
}
@media (max-width: 576px) {
  .home-room {
    margin-top: 2.25rem !important;
  }
}

.room-setting {
  color: var(--color-danger);
  background: transparent;
  font-family: Inter;
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 600;
  line-height: 2.25rem;
  text-align: left;
  margin-top: 0.5rem;
}

.contact-invite, .add-participants, .other-login {
  color: var(--color-accent);
  border: 1px solid var(--color-accent);
  height: 1.75rem;
  border-radius: 0.875rem;
  padding: 0px 0.219rem;
  font-weight: 600;
  font-size: 0.813rem;
  background: transparent;
  transition: background 0.12s;
}
.contact-invite:hover, .add-participants:hover, .other-login:hover {
  background: rgba(76, 23, 202, 0.08);
}
.contact-invite:active, .add-participants:active, .other-login:active {
  background: rgba(76, 23, 202, 0.15);
}

.contact-invite-new {
  height: 2.5rem;
  font-size: 0.875rem;
  line-height: 2.25rem;
  z-index: 1;
  border-radius: 1.25rem;
  letter-spacing: 0.84px;
  color: var(--surface-primary);
  background: var(--color-accent);
  padding-left: 1.8125rem;
  padding-right: 1.8125rem;
  transition: background 0.12s;
}
.contact-invite-new:hover {
  background: #3d12a2;
}
.contact-invite-new:active {
  background: #2e0d85;
}
@media (max-width: 576px) {
  .contact-invite-new {
    padding-left: 0px;
    padding-right: 0px;
    height: 3.5rem;
    width: 3.5rem;
    position: fixed;
    bottom: 3.875rem;
    right: 1rem;
    opacity: 1;
    border-radius: 50%;
  }
}

.contact-invite-toolbar {
  height: 1.75rem;
  border-radius: 0.875rem;
  padding: 0px 0.219rem;
  font-weight: 600;
  font-size: 0.813rem;
}
@media (max-width: 1124px) {
  .contact-invite-toolbar {
    display: none;
  }
}

.logout, .volume-test-button {
  color: var(--color-danger);
  border: 1px solid var(--color-danger);
  height: 1.75rem;
  border-radius: 1rem;
  font-weight: 600;
  font-size: 0.813rem;
  letter-spacing: 0.78px;
  width: min-content;
  background: transparent;
  padding-left: 11.9px;
  padding-right: 11.9px;
  transition: background 0.12s;
}
.logout:hover, .volume-test-button:hover {
  background: rgba(224, 30, 90, 0.08);
}
.logout:active, .volume-test-button:active {
  background: rgba(224, 30, 90, 0.15);
}
@media (max-width: 576px) {
  .logout, .volume-test-button {
    margin-top: 1rem;
    border-radius: 1.125rem;
    width: 10.25rem;
    height: 2.25rem;
    font-size: 0.875rem;
    letter-spacing: 0.84px;
    padding-left: 3.375rem;
    padding-right: 3.375rem;
  }
}

.signout {
  color: var(--color-danger);
  border: 1px solid var(--color-danger);
  height: 1.75rem;
  border-radius: 1rem;
  font-weight: 600;
  font-size: 0.813rem;
  letter-spacing: 0.78px;
  width: min-content;
  background: transparent;
  padding-left: 11.9px;
  padding-right: 11.9px;
}

@media (max-width: 576px) {
  .apply-button {
    width: 12rem !important;
  }
}
.notification-button {
  color: var(--text-secondary);
  position: relative;
}
@media (min-width: 576px) {
  .notification-button {
    position: absolute !important;
    right: 6.75rem !important;
    top: 1.438rem;
  }
}
.notification-button app-icon {
  width: 1.5rem;
  height: 1.5rem;
}

@media (max-width: 576px) {
  .notification-button-position {
    right: 0.563rem;
  }
}

.footer-button {
  color: #D7D8DA;
  position: relative;
}
.footer-button app-icon {
  font-size: 1.5rem;
}
.footer-button .active {
  color: var(--color-accent);
}

.other-login {
  height: 2.25rem !important;
  border-radius: 1rem !important;
  font-size: 0.875rem !important;
  padding-left: 0.625rem;
  padding-right: 0.625rem;
}

.subscription-button {
  height: 2.25rem;
  font-weight: 600;
  font-size: 0.85rem;
  line-height: 2.25rem;
  color: var(--text-on-dark);
  background: var(--color-accent);
  border-radius: 1.125rem;
  padding: 0 1.25rem;
  width: 100%;
  transition: background 0.12s;
}
.subscription-button:hover:not(:disabled) {
  background: #3d12a2;
}
.subscription-button:active:not(:disabled) {
  background: #2e0d85;
}

.room-leave-button {
  height: 2.25rem;
  font-weight: 600;
  font-size: 0.813rem !important;
  letter-spacing: 0.78px;
  margin-left: 1rem;
  padding-left: 1.156rem;
  padding-right: 1.156rem;
  border-radius: 0.5rem;
  color: #ffffff;
  background: oklch(63.7% 0.237 25.331deg);
  transition: background-color 150ms cubic-bezier(0.4, 0, 0.2, 1);
}
.room-leave-button:hover {
  background: oklch(57.7% 0.245 27.325deg);
}
.room-leave-button:active {
  background: #a81644;
}
@media (max-width: 576px) {
  .room-leave-button {
    height: 1.75rem;
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }
}

.contact-chat, .participant-warning-close-button, .close-button,
.chat-close-button, .scroll-forward-button, .scroll-button {
  background: transparent;
  padding: 0;
  border-radius: 50%;
  height: 2.5rem;
  width: 2.5rem;
}

.share-invite {
  height: 2.5rem;
  background: var(--color-accent);
  color: var(--surface-primary);
  padding-left: 1.6rem;
  padding-right: 1.6rem;
  font-weight: 600;
  font-size: 0.875rem !important;
  letter-spacing: 0.84px;
  line-height: 2.25rem;
  transition: background 0.12s;
}
.share-invite:hover {
  background: #3d12a2;
}
.share-invite:active {
  background: #2e0d85;
}

.scroll-button {
  margin-left: 2rem;
}

.scroll-forward-button {
  margin-right: 2rem;
  position: relative;
  z-index: 2;
}

.room-participants-buttons {
  width: 1.9375rem;
  height: 1.9375rem;
  border-radius: 0.5rem;
}

.submenu-background-color {
  background: rgba(0, 0, 0, 0.55);
  -webkit-backdrop-filter: blur(4px);
          backdrop-filter: blur(4px);
  transition: background 0.12s;
}
.submenu-background-color:hover {
  background: rgba(0, 0, 0, 0.75);
}

.red-background-color {
  background: var(--color-danger);
}

.yellow-background-color {
  background: #FF5322;
}

.close-button:hover,
.chat-close-button:hover {
  background: rgba(0, 0, 0, 0.04);
}

.participant-warning-close-button {
  float: right;
}
.participant-warning-close-button:hover {
  background: rgba(255, 255, 255, 0.04);
}

.modal-close-button {
  height: 2.5rem;
  width: 2.5rem;
  border-radius: 50%;
  transition: background 0.12s;
}
.modal-close-button:hover {
  background: var(--surface-hover);
}
.modal-close-button:active {
  background: var(--border-default);
}

.room-participant-list-button {
  background: transparent;
  padding: 0;
  border-radius: 0;
}

.accept-call-button, .cancel-call-button {
  height: 2.5rem;
  width: 2.5rem;
  border-radius: 50%;
  background-color: var(--color-accent);
  color: var(--surface-primary);
}
@media (max-width: 576px) {
  .accept-call-button, .cancel-call-button {
    height: 3.125rem;
    width: 3.125rem;
  }
}

.video-call-button, .audio-call-button, .call-inactive, .chat-button {
  height: 3.5rem;
  width: 3.5rem;
  border-radius: 50%;
  color: var(--surface-primary);
  background: var(--color-accent);
  margin-right: 0.4375rem;
  margin-left: 0.4375rem;
  padding: 0;
}

.call-inactive {
  background: var(--text-secondary);
}

.cancel-call-button {
  background-color: var(--color-danger);
}

.invite-org-contacts {
  height: 2.25rem;
  background: var(--color-accent);
  color: var(--surface-primary);
  padding-left: 2.125rem;
  padding-right: 2.125rem;
  font-weight: 600;
  font-size: 0.875rem !important;
  letter-spacing: 0.84px;
  line-height: 2.25rem;
  transition: background 0.12s;
}
.invite-org-contacts:hover {
  background: #3d12a2;
}
.invite-org-contacts:active {
  background: #2e0d85;
}

.volume-test-button {
  color: #FF5322;
  border: 1px solid #FF5322;
  margin-left: -4rem;
  width: auto;
  white-space: nowrap;
  height: 2.25rem;
  border-radius: 0.5rem;
  transition: background-color 150ms cubic-bezier(0.4, 0, 0.2, 1), color 150ms cubic-bezier(0.4, 0, 0.2, 1);
}
.volume-test-button:hover {
  background: rgba(255, 83, 34, 0.08);
}
.volume-test-button:active {
  background: rgba(255, 83, 34, 0.15);
}

.help-button {
  padding-right: 0.2rem !important;
}

.settings-button {
  height: 2.25rem;
  border-radius: 50%;
  padding-right: 0.6rem;
}

.add-participants {
  width: -moz-fit-content;
  width: fit-content;
  padding: 0px 0rem;
  border: none;
  padding-left: 0.9375rem;
  padding-right: 0.9375rem;
}

.recording-buttons {
  height: 1.3125rem;
  margin-bottom: 20%;
  border-radius: 50%;
  padding: 0px !important;
}

.recording-button-right {
  margin-right: 1rem;
  margin-bottom: 18%;
}

.edit-org {
  color: var(--color-accent);
  border: 1px solid var(--color-accent);
  background: transparent;
  border-radius: 3rem !important;
  height: 2.5rem;
  font-weight: 600;
  font-size: 0.813rem !important;
  letter-spacing: 0.78px;
  line-height: 1.706rem;
  padding-left: 1.156rem;
  padding-right: 1.156rem;
  transition: background 0.12s;
}
.edit-org:hover {
  background: rgba(76, 23, 202, 0.08);
}
.edit-org:active {
  background: rgba(76, 23, 202, 0.15);
}

.accept-invite, .cancel-invite {
  height: 2.25rem;
  border-radius: 1.125rem;
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 600;
  line-height: 2.25rem;
  letter-spacing: 0.8399999738px;
  background: var(--color-accent);
  color: var(--surface-primary);
  padding-left: 4.4rem;
  padding-right: 4.4rem;
  transition: background 0.12s;
}
.accept-invite:hover, .cancel-invite:hover {
  background: #3d12a2;
}
.accept-invite:active, .cancel-invite:active {
  background: #2e0d85;
}
@media (max-width: 430px) {
  .accept-invite, .cancel-invite {
    padding-left: 0rem;
    padding-right: 0rem;
    width: 44vw;
  }
}

.cancel-invite {
  color: var(--color-accent);
  border: 1px solid var(--color-accent);
  background: transparent;
  margin-right: 1.875rem;
}
@media (max-width: 430px) {
  .cancel-invite {
    margin-right: 0.875rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/UI-Components/button/button.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB,qDAAA;AACA;EACI,qBAAA;AAEJ;;AACA;EACI,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,oBAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;EACA,uBAAA;EACA,cAAA;EACA,UAAA;EACA,SAAA;EACA,oBAAA;EACA,uBAAA;EACA,cAAA;EACA,aAAA;EACA,wBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;AAEJ;AAAI;EACI,YAAA;EACA,eAAA;AAER;AACI;EACI,UAAA;EACA,eAAA;AACR;AAEI;EACI,aAAA;AAAR;;AAIA;EACI,qBAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EACA,+BAAA;EACA,kBAAA;EACA,wCAAA;AADJ;;AAIA;EACI;IAAK,yBAAA;EAAP;AACF;AAEA;EACI,oBAAA;EACA,gBAAA;AAAJ;;AAGA;EACI,gBAAA;EACA,uBAAA;EACA,eAAA;EACA,uBAAA;EACA,wBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,+BAAA;EACA,WAAA;EACA,eAAA;EACA,4BAAA;AAAJ;AAEI;EACI,mBAAA;AAAR;AAGI;EACI,mBAAA;AADR;AAII;EACI,YAAA;EACA,eAAA;AAFR;;AAMA;EACI,0BAAA;EACA,qCAAA;EACA,eAAA;EACA,uBAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;EACA,4BAAA;AAHJ;AAKI;EACI,mCAAA;AAHR;AAMI;EACI,mCAAA;AAJR;AAOI;EAlBJ;IAmBQ,eAAA;IACA,oBAAA;IACA,uBAAA;IACA,qBAAA;IACA,qBAAA;EAJN;AACF;;AAOA;EAEI,eAAA;EACA,oBAAA;EACA,uBAAA;EACA,iBAAA;EACA,qBAAA;AALJ;AAOI;EARJ;IASQ,mBAAA;EAJN;AACF;;AAOA;EACI,YAAA;EACA,mBAAA;EACA,+BAAA;EACA,6BAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,wBAAA;EACA,cAAA;EACA,mBAAA;EACA,YAAA;AAJJ;;AAOA;EACI,4BAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,qBAAA;EACA,YAAA;EACA,oCAAA;AAJJ;AAMI;EACI,oCAAA;AAJR;;AAQA;EACI,0BAAA;EACA,qCAAA;EACA,eAAA;EACA,uBAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;EACA,4BAAA;AALJ;AAOI;EACI,mCAAA;AALR;AAQI;EACI,mCAAA;AANR;AASI;EAlBJ;IAmBQ,eAAA;IACA,oBAAA;IACA,uBAAA;IACA,qBAAA;IACA,qBAAA;EANN;AACF;;AASA;EACI,cAAA;EACA,aAAA;EACA,yBAAA;EACA,sBAAA;EACA,gDAAA;AANJ;AAQI;EACI,mCAAA;EACA,mCAAA;AANR;AASI;EACI,iCAAA;AAPR;;AAWA;EACI,gBAAA;AARJ;AAUI;EAHJ;IAIQ,mBAAA;EAPN;AACF;;AAUA;EACI,kBAAA;AAPJ;AASI;EAHJ;IAIQ,qBAAA;EANN;AACF;;AASA;EACI,WAAA;EACA,YAAA;EACA,0BAAA;EACA,eAAA;EACA,mBAAA;EACA,oCAAA;AANJ;;AASA;EACI,gBAAA;EACA,eAAA;EACA,uBAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,oBAAA;EACA,+BAAA;EACA,WAAA;EACA,mBAAA;EACA,2CAAA;AANJ;AAQI;EACI,mBAAA;AANR;AASI;EACI,mBAAA;AAPR;AAUI;EAxBJ;IAyBQ,kBAAA;IACA,kBAAA;EAPN;AACF;AASI;EA7BJ;IA8BQ,gBAAA;EANN;AACF;;AASA;EAEI,uBAAA;EACA,0BAAA;EACA,qCAAA;EACA,uBAAA;AAPJ;AASI;EACI,mCAAA;AAPR;AAUI;EACI,mCAAA;AARR;;AAYA;EAEI,uBAAA;EACA,4BAAA;EACA,uCAAA;EACA,uBAAA;AAVJ;AAYI;EAPJ;IAQQ,4BAAA;IACA,uCAAA;IACA,uBAAA;EATN;AACF;;AAYA;EAEI,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,0BAAA;EACA,sBAAA;EACA,qCAAA;EACA,uBAAA;EACA,kBAAA;EACA,mBAAA;AAVJ;;AAaA;EAEI,2BAAA;AAXJ;AAaI;EAJJ;IAKQ,8BAAA;EAVN;AACF;;AAaA;EACI,0BAAA;EACA,uBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;EACA,gBAAA;EACA,kBAAA;AAVJ;;AAaA;EACI,0BAAA;EACA,qCAAA;EACA,eAAA;EACA,uBAAA;EACA,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,4BAAA;AAVJ;AAYI;EACI,mCAAA;AAVR;AAaI;EACI,mCAAA;AAXR;;AAeA;EACI,cAAA;EACA,mBAAA;EACA,oBAAA;EACA,UAAA;EACA,sBAAA;EACA,sBAAA;EACA,6BAAA;EACA,+BAAA;EACA,uBAAA;EACA,wBAAA;EACA,4BAAA;AAZJ;AAcI;EACI,mBAAA;AAZR;AAeI;EACI,mBAAA;AAbR;AAgBI;EArBJ;IAsBQ,iBAAA;IACA,kBAAA;IACA,cAAA;IACA,aAAA;IACA,eAAA;IACA,gBAAA;IACA,WAAA;IACA,UAAA;IACA,kBAAA;EAbN;AACF;;AAgBA;EACI,eAAA;EACA,uBAAA;EACA,qBAAA;EACA,gBAAA;EACA,mBAAA;AAbJ;AAeI;EAPJ;IAQQ,aAAA;EAZN;AACF;;AAeA;EACI,0BAAA;EACA,qCAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;EACA,uBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;AAZJ;AAcI;EACI,mCAAA;AAZR;AAeI;EACI,mCAAA;AAbR;AAgBI;EAtBJ;IAuBQ,gBAAA;IACA,uBAAA;IACA,eAAA;IACA,eAAA;IACA,mBAAA;IACA,sBAAA;IACA,sBAAA;IACA,uBAAA;EAbN;AACF;;AAgBA;EACI,0BAAA;EACA,qCAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;EACA,uBAAA;EACA,oBAAA;EACA,qBAAA;AAbJ;;AAgBA;EACI;IACI,uBAAA;EAbN;AACF;AAgBA;EACI,4BAAA;EACA,kBAAA;AAdJ;AAgBI;EAJJ;IAKQ,6BAAA;IACA,yBAAA;IACA,aAAA;EAbN;AACF;AAeI;EACI,aAAA;EACA,cAAA;AAbR;;AAkBI;EADJ;IAEQ,eAAA;EAdN;AACF;;AAiBA;EACI,cAAA;EACA,kBAAA;AAdJ;AAgBI;EACI,iBAAA;AAdR;AAiBI;EACI,0BAAA;AAfR;;AAmBA;EAEI,0BAAA;EACA,8BAAA;EACA,8BAAA;EACA,sBAAA;EACA,uBAAA;AAjBJ;;AAoBA;EACI,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;EACA,0BAAA;EACA,+BAAA;EACA,uBAAA;EACA,kBAAA;EACA,WAAA;EACA,4BAAA;AAjBJ;AAmBI;EACI,mBAAA;AAjBR;AAoBI;EACI,mBAAA;AAlBR;;AAsBA;EACI,eAAA;EACA,gBAAA;EACA,8BAAA;EACA,sBAAA;EACA,iBAAA;EACA,sBAAA;EACA,uBAAA;EACA,qBAAA;EACA,cAAA;EACA,wCAAA;EACA,+DAAA;AAnBJ;AAqBI;EACI,wCAAA;AAnBR;AAsBI;EACI,mBAAA;AApBR;AAuBI;EArBJ;IAsBQ,eAAA;IACA,qBAAA;IACA,sBAAA;EApBN;AACF;;AAuBA;;EACI,uBAAA;EACA,UAAA;EACA,kBAAA;EACA,cAAA;EACA,aAAA;AAnBJ;;AAsBA;EACI,cAAA;EACA,+BAAA;EACA,6BAAA;EACA,oBAAA;EACA,qBAAA;EACA,gBAAA;EACA,8BAAA;EACA,sBAAA;EACA,oBAAA;EACA,4BAAA;AAnBJ;AAqBI;EACI,mBAAA;AAnBR;AAsBI;EACI,mBAAA;AApBR;;AAwBA;EAEI,iBAAA;AAtBJ;;AAyBA;EAEI,kBAAA;EACA,kBAAA;EACA,UAAA;AAvBJ;;AA0BA;EACI,gBAAA;EACA,iBAAA;EACA,qBAAA;AAvBJ;;AA0BA;EACI,+BAAA;EACA,kCAAA;UAAA,0BAAA;EACA,4BAAA;AAvBJ;AAyBI;EACI,+BAAA;AAvBR;;AA2BA;EACI,+BAAA;AAxBJ;;AA2BA;EACI,mBAAA;AAxBJ;;AA+BI;;EACI,+BAAA;AA3BR;;AA+BA;EACI,YAAA;AA5BJ;AA+BI;EACI,qCAAA;AA7BR;;AAiCA;EACI,cAAA;EACA,aAAA;EACA,kBAAA;EACA,4BAAA;AA9BJ;AAgCI;EACI,gCAAA;AA9BR;AAiCI;EACI,iCAAA;AA/BR;;AAmCA;EACI,uBAAA;EACA,UAAA;EACA,gBAAA;AAhCJ;;AAmCA;EACI,cAAA;EACA,aAAA;EACA,kBAAA;EACA,qCAAA;EACA,6BAAA;AAhCJ;AAkCI;EAPJ;IAQQ,gBAAA;IACA,eAAA;EA/BN;AACF;;AAkCA;EACI,cAAA;EACA,aAAA;EACA,kBAAA;EACA,6BAAA;EACA,+BAAA;EACA,uBAAA;EACA,sBAAA;EACA,UAAA;AA/BJ;;AAkCA;EAEE,iCAAA;AAhCF;;AAmCA;EAEI,qCAAA;AAjCJ;;AAoCA;EACI,eAAA;EACA,+BAAA;EACA,6BAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;EACA,8BAAA;EACA,sBAAA;EACA,oBAAA;EACA,4BAAA;AAjCJ;AAmCI;EACI,mBAAA;AAjCR;AAoCI;EACI,mBAAA;AAlCR;;AAsCA;EAEI,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,eAAA;EACA,qBAAA;EACA,yGAAA;AApCJ;AAuCI;EACI,mCAAA;AArCR;AAwCI;EACI,mCAAA;AAtCR;;AA0CA;EACI,gCAAA;AAvCJ;;AA0CA;EACI,eAAA;EACA,kBAAA;EACA,qBAAA;AAvCJ;;AA0CA;EAEI,uBAAA;EAAA,kBAAA;EACA,iBAAA;EACA,YAAA;EACA,uBAAA;EACA,wBAAA;AAxCJ;;AA2CA;EACI,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,uBAAA;AAxCJ;;AA2CA;EACI,kBAAA;EACA,kBAAA;AAxCJ;;AA2CA;EACI,0BAAA;EACA,qCAAA;EACA,uBAAA;EACA,8BAAA;EACA,cAAA;EACA,gBAAA;EACA,8BAAA;EACA,sBAAA;EACA,qBAAA;EACA,sBAAA;EACA,uBAAA;EACA,4BAAA;AAxCJ;AA0CI;EACI,mCAAA;AAxCR;AA2CI;EACI,mCAAA;AAzCR;;AA6CA;EACI,eAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;EACA,8BAAA;EACA,+BAAA;EACA,6BAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;AA1CJ;AA4CI;EACI,mBAAA;AA1CR;AA6CI;EACI,mBAAA;AA3CR;AA8CI;EAtBJ;IAuBQ,kBAAA;IACA,mBAAA;IACA,WAAA;EA3CN;AACF;;AA8CA;EAEI,0BAAA;EACA,qCAAA;EACA,uBAAA;EACA,sBAAA;AA5CJ;AA8CI;EAPJ;IAQQ,sBAAA;EA3CN;AACF","sourcesContent":["/* Base button reset — replaces ion-button defaults */\n:host {\n    display: inline-block;\n}\n\nbutton {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    font-family: inherit;\n    font-size: inherit;\n    cursor: pointer;\n    border: none;\n    background: transparent;\n    color: inherit;\n    padding: 0;\n    margin: 0;\n    text-transform: none;\n    letter-spacing: inherit;\n    line-height: 1;\n    outline: none;\n    -webkit-appearance: none;\n    appearance: none;\n    white-space: nowrap;\n    box-sizing: border-box;\n\n    &:disabled {\n        opacity: 0.5;\n        cursor: default;\n    }\n\n    &.btn-loading {\n        opacity: 1;\n        cursor: default;\n    }\n\n    &[hidden] {\n        display: none;\n    }\n}\n\n.btn-spinner {\n    display: inline-block;\n    width: 1rem;\n    height: 1rem;\n    border: 2px solid currentColor;\n    border-right-color: transparent;\n    border-radius: 50%;\n    animation: btn-spin 0.6s linear infinite;\n}\n\n@keyframes btn-spin {\n    to { transform: rotate(360deg); }\n}\n\n.button {\n    text-transform: none;\n    box-shadow: none;\n}\n\n.register-button {\n    box-shadow: none;\n    text-transform: inherit;\n    height: 2.25rem;\n    padding-left: 1.1875rem;\n    padding-right: 1.1875rem;\n    border-radius: 1.125rem;\n    font-size: 0.875rem;\n    font-weight: 600;\n    min-width: 12rem;\n    border: none;\n    background: var(--color-accent);\n    color: #fff;\n    cursor: pointer;\n    transition: background 0.12s;\n\n    &:hover:not(:disabled) {\n        background: #3d12a2;\n    }\n\n    &:active:not(:disabled) {\n        background: #2e0d85;\n    }\n\n    &:disabled {\n        opacity: 0.5;\n        cursor: default;\n    }\n}\n\n.sign-up {\n    color: var(--color-accent);\n    border: 1px solid var(--color-accent);\n    height: 2.25rem;\n    border-radius: 1.125rem;\n    padding: 0px 1.625rem;\n    font-size: 0.875rem;\n    font-weight: 600;\n    transition: background 0.12s;\n\n    &:hover {\n        background: rgba(76, 23, 202, 0.08);\n    }\n\n    &:active {\n        background: rgba(76, 23, 202, 0.15);\n    }\n\n    @media(max-width: 500px) {\n        height: 1.75rem;\n        font-size: 0.8125rem;\n        border-radius: 0.875rem;\n        padding: 0px 0.188rem;\n        margin-top: -0.938rem;\n    }\n}\n\n.sign-up-new {\n    @extend .sign-up;\n    height: 1.75rem;\n    font-size: 0.8125rem;\n    border-radius: 0.875rem;\n    padding: 0 0.8rem;\n    margin-top: -0.938rem;\n\n    @media(max-width: 300px) {\n        font-size: 0.625rem;\n    }\n}\n\n.new-signup-button {\n    width: 100vw;\n    border-radius: 0rem;\n    background: var(--color-accent);\n    color: var(--surface-primary);\n    font-weight: 600;\n    font-size: 1.25rem;\n    line-height: 3.5rem;\n    letter-spacing: 0.075rem;\n    height: 3.5rem;\n    margin-inline: 0rem;\n    margin: 0rem;\n}\n\n.language-button {\n    color: var(--text-secondary);\n    height: 1.75rem;\n    font-size: 0.9rem;\n    padding: 0 0.5rem;\n    margin-top: -0.938rem;\n    gap: 0.25rem;\n    background: var(--surface-secondary);\n\n    &:hover {\n        background: var(--surface-secondary);\n    }\n}\n\n.sign-in {\n    color: var(--color-accent);\n    border: 1px solid var(--color-accent);\n    height: 2.25rem;\n    border-radius: 1.125rem;\n    padding: 0px 1.375rem;\n    font-size: 0.875rem;\n    font-weight: 600;\n    transition: background 0.12s;\n\n    &:hover {\n        background: rgba(76, 23, 202, 0.08);\n    }\n\n    &:active {\n        background: rgba(76, 23, 202, 0.15);\n    }\n\n    @media(max-width: 500px) {\n        height: 1.75rem;\n        font-size: 0.8125rem;\n        border-radius: 0.875rem;\n        padding: 0px 0.281rem;\n        margin-top: -0.938rem;\n    }\n}\n\n.social-icons {\n    height: 3.5rem;\n    width: 3.5rem;\n    border: 1px solid #D7D8DA;\n    border-radius: 0.75rem;\n    transition: background 0.12s, border-color 0.12s;\n\n    &:hover {\n        background: var(--surface-tertiary);\n        border-color: var(--border-default);\n    }\n\n    &:active {\n        background: var(--surface-active);\n    }\n}\n\n.spacing {\n    margin: 0px 2rem;\n\n    @media(max-width: 350px) {\n        margin: 0px 1.25rem;\n    }\n}\n\n.spacing-right {\n    margin-right: 2rem;\n\n    @media(max-width: 350px) {\n        margin-right: 1.25rem;\n    }\n}\n\n.forgot-password {\n    margin: 0px;\n    padding: 0px;\n    color: var(--color-accent);\n    height: 2.25rem;\n    font-size: 0.875rem;\n    background: var(--surface-secondary);\n}\n\n.home-new-meeting {\n    min-width: 12rem;\n    height: 2.25rem;\n    border-radius: 1.125rem;\n    padding-left: 0.963rem;\n    padding-right: 0.963rem;\n    font-weight: 600;\n    font-size: 0.875rem;\n    margin: 0px;\n    margin-top: 1.5rem;\n    margin-right: 1.5rem;\n    background: var(--color-accent);\n    color: #fff;\n    white-space: nowrap;\n    transition: background 0.12s, opacity 0.12s;\n\n    &:hover {\n        background: #3d12a2;\n    }\n\n    &:active {\n        background: #2e0d85;\n    }\n\n    @media(max-width: 576px) {\n        min-width: 9.25rem;\n        margin-right: 1rem;\n    }\n\n    @media(max-width: 375px) {\n        min-width: 14rem;\n    }\n}\n\n.meet-later {\n    @extend .home-new-meeting;\n    border-radius: 1.125rem;\n    color: var(--color-danger);\n    border: 1px solid var(--color-danger);\n    background: transparent;\n\n    &:hover {\n        background: rgba(255, 83, 34, 0.08);\n    }\n\n    &:active {\n        background: rgba(255, 83, 34, 0.15);\n    }\n}\n\n.cancel-rename {\n    @extend .home-new-meeting;\n    border-radius: 1.125rem;\n    color: var(--text-secondary);\n    border: 1px solid var(--text-secondary);\n    background: transparent;\n\n    @media(min-width: 576px) {\n        color: var(--text-secondary);\n        border: 1px solid var(--text-secondary);\n        background: transparent;\n    }\n}\n\n.delete-contact {\n    @extend .home-new-meeting;\n    min-width: 8rem;\n    margin-top: 1rem;\n    margin-bottom: 1rem;\n    color: var(--color-danger);\n    border-radius: 1.25rem;\n    border: 1px solid var(--color-danger);\n    background: transparent;\n    padding-left: 1rem;\n    padding-right: 1rem;\n}\n\n.home-room {\n    @extend .home-new-meeting;\n    margin-top: 3rem !important;\n\n    @media(max-width: 576px) {\n        margin-top: 2.25rem !important;\n    }\n}\n\n.room-setting {\n    color: var(--color-danger);\n    background: transparent;\n    font-family: Inter;\n    font-size: 0.875rem;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 2.25rem;\n    text-align: left;\n    margin-top: 0.5rem;\n}\n\n.contact-invite {\n    color: var(--color-accent);\n    border: 1px solid var(--color-accent);\n    height: 1.75rem;\n    border-radius: 0.875rem;\n    padding: 0px 0.219rem;\n    font-weight: 600;\n    font-size: 0.813rem;\n    background: transparent;\n    transition: background 0.12s;\n\n    &:hover {\n        background: rgba(76, 23, 202, 0.08);\n    }\n\n    &:active {\n        background: rgba(76, 23, 202, 0.15);\n    }\n}\n\n.contact-invite-new {\n    height: 2.5rem;\n    font-size: 0.875rem;\n    line-height: 2.25rem;\n    z-index: 1;\n    border-radius: 1.25rem;\n    letter-spacing: 0.84px;\n    color: var(--surface-primary);\n    background: var(--color-accent);\n    padding-left: 1.8125rem;\n    padding-right: 1.8125rem;\n    transition: background 0.12s;\n\n    &:hover {\n        background: #3d12a2;\n    }\n\n    &:active {\n        background: #2e0d85;\n    }\n\n    @media(max-width: 576px) {\n        padding-left: 0px;\n        padding-right: 0px;\n        height: 3.5rem;\n        width: 3.5rem;\n        position: fixed;\n        bottom: 3.875rem;\n        right: 1rem;\n        opacity: 1;\n        border-radius: 50%;\n    }\n}\n\n.contact-invite-toolbar {\n    height: 1.75rem;\n    border-radius: 0.875rem;\n    padding: 0px 0.219rem;\n    font-weight: 600;\n    font-size: 0.813rem;\n\n    @media(max-width: 1124px) {\n        display: none;\n    }\n}\n\n.logout {\n    color: var(--color-danger);\n    border: 1px solid var(--color-danger);\n    height: 1.75rem;\n    border-radius: 1rem;\n    font-weight: 600;\n    font-size: 0.813rem;\n    letter-spacing: 0.78px;\n    width: min-content;\n    background: transparent;\n    padding-left: 11.9px;\n    padding-right: 11.9px;\n    transition: background 0.12s;\n\n    &:hover {\n        background: rgba(224, 30, 90, 0.08);\n    }\n\n    &:active {\n        background: rgba(224, 30, 90, 0.15);\n    }\n\n    @media(max-width: 576px) {\n        margin-top: 1rem;\n        border-radius: 1.125rem;\n        width: 10.25rem;\n        height: 2.25rem;\n        font-size: 0.875rem;\n        letter-spacing: 0.84px;\n        padding-left: 3.375rem;\n        padding-right: 3.375rem;\n    }\n}\n\n.signout {\n    color: var(--color-danger);\n    border: 1px solid var(--color-danger);\n    height: 1.75rem;\n    border-radius: 1rem;\n    font-weight: 600;\n    font-size: 0.813rem;\n    letter-spacing: 0.78px;\n    width: min-content;\n    background: transparent;\n    padding-left: 11.9px;\n    padding-right: 11.9px;\n}\n\n@media(max-width: 576px) {\n    .apply-button {\n        width: 12rem !important;\n    }\n}\n\n.notification-button {\n    color: var(--text-secondary);\n    position: relative;\n\n    @media(min-width: 576px) {\n        position: absolute !important;\n        right: 6.75rem !important;\n        top: 1.438rem;\n    }\n\n    app-icon {\n        width: 1.5rem;\n        height: 1.5rem;\n    }\n}\n\n.notification-button-position {\n    @media(max-width: 576px) {\n        right: 0.563rem;\n    }\n}\n\n.footer-button {\n    color: #D7D8DA;\n    position: relative;\n\n    app-icon {\n        font-size: 1.5rem\n    }\n\n    .active {\n        color: var(--color-accent);\n    }\n}\n\n.other-login {\n    @extend .contact-invite;\n    height: 2.25rem !important;\n    border-radius: 1rem !important;\n    font-size: 0.875rem !important;\n    padding-left: 0.625rem;\n    padding-right: 0.625rem;\n}\n\n.subscription-button {\n    height: 2.25rem;\n    font-weight: 600;\n    font-size: 0.85rem;\n    line-height: 2.25rem;\n    color: var(--text-on-dark);\n    background: var(--color-accent);\n    border-radius: 1.125rem;\n    padding: 0 1.25rem;\n    width: 100%;\n    transition: background 0.12s;\n\n    &:hover:not(:disabled) {\n        background: #3d12a2;\n    }\n\n    &:active:not(:disabled) {\n        background: #2e0d85;\n    }\n}\n\n.room-leave-button {\n    height: 2.25rem;\n    font-weight: 600;\n    font-size: 0.813rem !important;\n    letter-spacing: 0.78px;\n    margin-left: 1rem;\n    padding-left: 1.156rem;\n    padding-right: 1.156rem;\n    border-radius: 0.5rem;\n    color: #ffffff;\n    background: oklch(63.7% 0.237 25.331);\n    transition: background-color 150ms cubic-bezier(0.4, 0, 0.2, 1);\n\n    &:hover {\n        background: oklch(57.7% 0.245 27.325);\n    }\n\n    &:active {\n        background: #a81644;\n    }\n\n    @media(max-width: 576px) {\n        height: 1.75rem;\n        padding-left: 0.75rem;\n        padding-right: 0.75rem;\n    }\n}\n\n.contact-chat {\n    background: transparent;\n    padding: 0;\n    border-radius: 50%;\n    height: 2.5rem;\n    width: 2.5rem;\n}\n\n.share-invite {\n    height: 2.5rem;\n    background: var(--color-accent);\n    color: var(--surface-primary);\n    padding-left: 1.6rem;\n    padding-right: 1.6rem;\n    font-weight: 600;\n    font-size: 0.875rem !important;\n    letter-spacing: 0.84px;\n    line-height: 2.25rem;\n    transition: background 0.12s;\n\n    &:hover {\n        background: #3d12a2;\n    }\n\n    &:active {\n        background: #2e0d85;\n    }\n}\n\n.scroll-button {\n    @extend .contact-chat;\n    margin-left: 2rem;\n}\n\n.scroll-forward-button {\n    @extend .contact-chat;\n    margin-right: 2rem;\n    position: relative;\n    z-index: 2;\n}\n\n.room-participants-buttons {\n    width: 1.9375rem;\n    height: 1.9375rem;\n    border-radius: 0.5rem;\n}\n\n.submenu-background-color {\n    background: rgba(0, 0, 0, 0.55);\n    backdrop-filter: blur(4px);\n    transition: background 0.12s;\n\n    &:hover {\n        background: rgba(0, 0, 0, 0.75);\n    }\n}\n\n.red-background-color {\n    background: var(--color-danger);\n}\n\n.yellow-background-color {\n    background: #FF5322;\n}\n\n.close-button,\n.chat-close-button {\n    @extend .contact-chat;\n\n    &:hover {\n        background: rgba(0, 0, 0, 0.04);\n    }\n}\n\n.participant-warning-close-button {\n    float: right;\n    @extend .contact-chat;\n\n    &:hover {\n        background: rgba(255, 255, 255, 0.04);\n    }\n}\n\n.modal-close-button {\n    height: 2.5rem;\n    width: 2.5rem;\n    border-radius: 50%;\n    transition: background 0.12s;\n\n    &:hover {\n        background: var(--surface-hover);\n    }\n\n    &:active {\n        background: var(--border-default);\n    }\n}\n\n.room-participant-list-button {\n    background: transparent;\n    padding: 0;\n    border-radius: 0;\n}\n\n.accept-call-button {\n    height: 2.5rem;\n    width: 2.5rem;\n    border-radius: 50%;\n    background-color: var(--color-accent);\n    color: var(--surface-primary);\n\n    @media(max-width: 576px) {\n        height: 3.125rem;\n        width: 3.125rem;\n    }\n}\n\n.video-call-button, .audio-call-button, .chat-button {\n    height: 3.5rem;\n    width: 3.5rem;\n    border-radius: 50%;\n    color: var(--surface-primary);\n    background: var(--color-accent);\n    margin-right: 0.4375rem;\n    margin-left: 0.4375rem;\n    padding: 0;\n}\n\n.call-inactive {\n  @extend .audio-call-button;\n  background: var(--text-secondary);\n}\n\n.cancel-call-button {\n    @extend .accept-call-button;\n    background-color: var(--color-danger);\n}\n\n.invite-org-contacts {\n    height: 2.25rem;\n    background: var(--color-accent);\n    color: var(--surface-primary);\n    padding-left: 2.125rem;\n    padding-right: 2.125rem;\n    font-weight: 600;\n    font-size: 0.875rem !important;\n    letter-spacing: 0.84px;\n    line-height: 2.25rem;\n    transition: background 0.12s;\n\n    &:hover {\n        background: #3d12a2;\n    }\n\n    &:active {\n        background: #2e0d85;\n    }\n}\n\n.volume-test-button {\n    @extend .logout;\n    color: #FF5322;\n    border: 1px solid #FF5322;\n    margin-left: -4rem;\n    width: auto;\n    white-space: nowrap;\n    height: 2.25rem;\n    border-radius: 0.5rem;\n    transition: background-color 150ms cubic-bezier(0.4, 0, 0.2, 1),\n                color 150ms cubic-bezier(0.4, 0, 0.2, 1);\n\n    &:hover {\n        background: rgba(255, 83, 34, 0.08);\n    }\n\n    &:active {\n        background: rgba(255, 83, 34, 0.15);\n    }\n}\n\n.help-button {\n    padding-right: 0.2rem !important;\n}\n\n.settings-button {\n    height: 2.25rem;\n    border-radius: 50%;\n    padding-right: 0.6rem;\n}\n\n.add-participants {\n    @extend .contact-invite;\n    width: fit-content;\n    padding: 0px 0rem;\n    border: none;\n    padding-left: 0.9375rem;\n    padding-right: 0.9375rem;\n}\n\n.recording-buttons {\n    height: 1.3125rem;\n    margin-bottom: 20%;\n    border-radius: 50%;\n    padding: 0px !important;\n}\n\n.recording-button-right {\n    margin-right: 1rem;\n    margin-bottom: 18%;\n}\n\n.edit-org {\n    color: var(--color-accent);\n    border: 1px solid var(--color-accent);\n    background: transparent;\n    border-radius: 3rem !important;\n    height: 2.5rem;\n    font-weight: 600;\n    font-size: 0.813rem !important;\n    letter-spacing: 0.78px;\n    line-height: 1.706rem;\n    padding-left: 1.156rem;\n    padding-right: 1.156rem;\n    transition: background 0.12s;\n\n    &:hover {\n        background: rgba(76, 23, 202, 0.08);\n    }\n\n    &:active {\n        background: rgba(76, 23, 202, 0.15);\n    }\n}\n\n.accept-invite {\n    height: 2.25rem;\n    border-radius: 1.125rem;\n    font-size: 0.875rem;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 2.25rem;\n    letter-spacing: 0.8399999737739563px;\n    background: var(--color-accent);\n    color: var(--surface-primary);\n    padding-left: 4.4rem;\n    padding-right: 4.4rem;\n    transition: background 0.12s;\n\n    &:hover {\n        background: #3d12a2;\n    }\n\n    &:active {\n        background: #2e0d85;\n    }\n\n    @media(max-width: 430px) {\n        padding-left: 0rem;\n        padding-right: 0rem;\n        width: 44vw;\n    }\n}\n\n.cancel-invite {\n    @extend .accept-invite;\n    color: var(--color-accent);\n    border: 1px solid var(--color-accent);\n    background: transparent;\n    margin-right: 1.875rem;\n\n    @media(max-width: 430px) {\n        margin-right: 0.875rem;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
